import { memo, useMemo } from 'react';

import SpriteBaseIcon from './SpriteBaseIcon';
import getSpriteIconInitialAssets from './utils/getSpriteIconInitialAssets';

import type { SpriteIconBaseProps } from './types';

type SpriteImgIconProps = SpriteIconBaseProps;

const SpriteImgIcon = (props: SpriteImgIconProps) => {
  const { category, id, fontSize, style, ...others } = props;

  const { alt, src, placeholder } = useMemo(
    () => getSpriteIconInitialAssets(category, id),
    [category, id],
  );

  return (
    <SpriteBaseIcon
      {...others}
      alt={alt}
      fontSize={fontSize}
      style={style}
      src={src}
      placeholder={placeholder}
    />
  );
};

export default memo(SpriteImgIcon, (prevProps, nextProps) => {
  return prevProps.category === nextProps.category && prevProps.id === nextProps.id;
});
